'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getQuestions = (content) => { var _a; return (_a = content.items) === null || _a === void 0 ? void 0 : _a.map(({ question }) => question); };

exports.getQuestions = getQuestions;
//# sourceMappingURL=index.js.map
